import PropTypes from 'prop-types';

export const ERROR_AUTOCOMPLETE = 'error.autocomplete';

export const ErrorType = PropTypes.shape({
    present: PropTypes.bool.isRequired,
    id: PropTypes.string,
    level: PropTypes.string,
});
